import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Check } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [status, setStatus] = useState("pending");
  const [attempts, setAttempts] = useState(0);

  const poll = useCallback(async () => {
    if (!sid) return;
    try {
      const { data } = await api.get(`/payments/status/${sid}`);
      setStatus(data.payment_status);
      if (data.payment_status === "paid") {
        await refresh();
      }
    } catch { /* noop */ }
  }, [sid, refresh]);

  useEffect(() => {
    poll();
    const iv = setInterval(() => {
      setAttempts((a) => a + 1);
    }, 2000);
    return () => clearInterval(iv);
  }, [poll]);

  useEffect(() => { poll(); }, [attempts, poll]);

  useEffect(() => {
    if (attempts > 10) setStatus((s) => s === "pending" ? "timeout" : s);
  }, [attempts]);

  return (
    <div className="max-w-lg mx-auto py-24 px-6 text-center" data-testid="payment-success-page">
      {status === "paid" ? (
        <>
          <div className="w-16 h-16 rounded-full bg-[#C93B3B] flex items-center justify-center mx-auto">
            <Check className="w-8 h-8 text-white" />
          </div>
          <h1 className="font-serif text-4xl mt-8 text-[#F7ECEB]">Thank you.</h1>
          <p className="text-[#A89896] mt-4">Your payment is complete. For cuddle-therapist sessions the practitioner has 24 hours to accept — we'll email you the moment they respond, and refund you in full if they can't make it.</p>
          <button onClick={() => nav("/dashboard")} className="btn-primary mt-10" data-testid="success-dashboard-btn">
            Go to my dashboard
          </button>
        </>
      ) : status === "timeout" ? (
        <>
          <h1 className="font-serif text-3xl text-[#F7ECEB]">Still processing.</h1>
          <p className="text-[#A89896] mt-4">This is taking longer than expected. Check your dashboard shortly — the payment will settle in the background.</p>
          <Link to="/dashboard" className="btn-primary inline-block mt-6">Go to dashboard</Link>
        </>
      ) : (
        <>
          <h1 className="font-serif text-3xl text-[#F7ECEB]">Confirming your payment...</h1>
          <p className="text-[#A89896] mt-4">One moment.</p>
        </>
      )}
    </div>
  );
}
